module.exports = __webpack_public_path__ + "static/img/product_manufacture_UniSecurity.cd60356.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_manufacture_UniSecurity.png
// module id = mcDP
// module chunks = 0